
import { cloneDeep } from 'lodash';

export class UtilityFunctions {
  public static DeepClone<T>(target: T, source?: Partial<T>): T {
    target = cloneDeep(target);
    source = cloneDeep(source);

    if (target && source) {
      Object.assign(target, source);
      return cloneDeep(target);
    } else {
      return cloneDeep(target);
    }
  }

  public static newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      // tslint:disable-next-line:no-bitwise
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    }).toUpperCase();
  }
}
